import { render } from "./IndexChat.vue?vue&type=template&id=9a13f368"
import script from "./IndexChat.vue?vue&type=script&lang=js"
export * from "./IndexChat.vue?vue&type=script&lang=js"

import "./IndexChat.vue?vue&type=style&index=0&id=9a13f368&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__